module.exports = {
          srcSet: __webpack_public_path__ + "eca9e9be.jpg"+" 700w"+","+__webpack_public_path__ + "c8d380ac.jpg"+" 1400w"+","+__webpack_public_path__ + "ca3d52b4.jpg"+" 2100w"+","+__webpack_public_path__ + "c4778d64.jpg"+" 2573w",
          images:[ {path: __webpack_public_path__ + "eca9e9be.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "c8d380ac.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "ca3d52b4.jpg",width: 2100,height: 1401},{path: __webpack_public_path__ + "c4778d64.jpg",width: 2573,height: 1716}],
          src: __webpack_public_path__ + "eca9e9be.jpg",
          toString:function(){return __webpack_public_path__ + "eca9e9be.jpg"},
          
          width: 700,
          height: 467
        }